<div class="rbars">
  <div class="rbar-row" *ngFor="let r of rows()">
    <span class="rbar-st muted fz11">{{ r.star }}</span>
    <svg class="rbar-star" width="10" height="10" viewBox="0 0 24 24" fill="#f5a623"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.7 1.4 6.8L12 17.8 5.9 21.2l1.4-6.8L2.2 9.7l6.9-.7z"/></svg>
    <div class="rbar-track"><div class="rbar-fill" [style.width.%]="r.pct"></div></div>
    <span class="rbar-ct muted fz11">{{ r.count }}</span>
  </div>
</div>
